/**
 * Cookie Consent Management
 * 
 * Gestion du consentement aux cookies conforme au RGPD
 */

const COOKIE_CONSENT_KEY = 'neokasa_cookie_consent';
const COOKIE_CONSENT_VERSION = '1.0';

/**
 * Types de cookies
 */
export const COOKIE_TYPES = {
  NECESSARY: 'necessary',
  ANALYTICS: 'analytics',
};

/**
 * Récupère le consentement actuel depuis localStorage
 */
export const getCookieConsent = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) {
      return null;
    }

    const consent = JSON.parse(stored);
    // Vérifier la version pour gérer les mises à jour
    if (consent.version !== COOKIE_CONSENT_VERSION) {
      return null;
    }

    return consent;
  } catch (e) {
    return null;
  }
};

/**
 * Vérifie si l'utilisateur a déjà donné son consentement
 */
export const hasCookieConsent = () => {
  const consent = getCookieConsent();
  return consent !== null;
};

/**
 * Vérifie si un type de cookie spécifique est accepté
 */
export const isCookieTypeAccepted = (cookieType) => {
  const consent = getCookieConsent();
  if (!consent) {
    return false;
  }

  // Les cookies nécessaires sont toujours acceptés
  if (cookieType === COOKIE_TYPES.NECESSARY) {
    return true;
  }

  return consent.preferences[cookieType] === true;
};

/**
 * Sauvegarde le consentement dans localStorage
 */
export const saveCookieConsent = (preferences) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const consent = {
      version: COOKIE_CONSENT_VERSION,
      timestamp: new Date().toISOString(),
      preferences: {
        [COOKIE_TYPES.NECESSARY]: true, // Toujours true
        [COOKIE_TYPES.ANALYTICS]: preferences[COOKIE_TYPES.ANALYTICS] || false,
      },
    };

    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
    
    // Déclencher un événement personnalisé pour notifier les autres composants
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('cookieConsentUpdated', { detail: consent }));
    }
  } catch (e) {
    console.error('Erreur lors de la sauvegarde du consentement:', e);
  }
};

/**
 * Révoque le consentement (sauf les cookies nécessaires)
 */
export const revokeCookieConsent = () => {
  saveCookieConsent({
    [COOKIE_TYPES.NECESSARY]: true,
    [COOKIE_TYPES.ANALYTICS]: false,
  });
};

